function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { IlcIntl } from 'ilc-sdk/app';
import Cookies from 'js-cookie';
import { appIdToNameAndSlot } from '../common/utils';
import i18nCookie from '../common/i18nCookie';
import dispatchSynchronizedEvent from './dispatchSynchronizedEvent';
import singleSpaEvents from './constants/singleSpaEvents';
import ilcEvents from './constants/ilcEvents';
var _config = /*#__PURE__*/new WeakMap();
var _singleSpa = /*#__PURE__*/new WeakMap();
var _appErrorHandlerFactory = /*#__PURE__*/new WeakMap();
var _transitionManager = /*#__PURE__*/new WeakMap();
var _prevConfig = /*#__PURE__*/new WeakMap();
var _setIntl = /*#__PURE__*/new WeakMap();
var _onBeforeAppsMount = /*#__PURE__*/new WeakMap();
var _get = /*#__PURE__*/new WeakMap();
var _set = /*#__PURE__*/new WeakMap();
var I18n = /*#__PURE__*/function () {
  function I18n(config, singleSpa, appErrorHandlerFactory) {
    var _this = this;
    var transitionManager = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    _classCallCheck(this, I18n);
    _classPrivateFieldInitSpec(this, _config, void 0);
    _classPrivateFieldInitSpec(this, _singleSpa, void 0);
    _classPrivateFieldInitSpec(this, _appErrorHandlerFactory, void 0);
    _classPrivateFieldInitSpec(this, _transitionManager, void 0);
    _classPrivateFieldInitSpec(this, _prevConfig, void 0);
    _defineProperty(this, "unlocalizeUrl", function (v) {
      return IlcIntl.parseUrl(_classPrivateFieldGet(_config, _this), v).cleanUrl;
    });
    _defineProperty(this, "localizeUrl", function (url) {
      return IlcIntl.localizeUrl(_classPrivateFieldGet(_config, _this), url, _classPrivateFieldGet(_get, _this).call(_this));
    });
    /**
     * @param {object} conf
     * @param {string} [conf.locale]
     * @param {string} [conf.currency]
     * @return void
     */
    _classPrivateFieldInitSpec(this, _setIntl, function (conf) {
      if (conf.locale && !_classPrivateFieldGet(_config, _this).supported.locale.includes(conf.locale)) {
        throw new Error('Invalid locale passed');
      }
      if (conf.currency && !_classPrivateFieldGet(_config, _this).supported.currency.includes(conf.currency)) {
        throw new Error('Invalid currency passed');
      }
      conf = Object.assign(_classPrivateFieldGet(_get, _this).call(_this), conf); //We need to fill the missing properties with curr values

      var url = window.location.href.replace(window.location.origin, '');
      var newLocaleUrl = IlcIntl.localizeUrl(_classPrivateFieldGet(_config, _this), url, conf);
      _classPrivateFieldGet(_set, _this).call(_this, conf);
      if (url !== newLocaleUrl) {
        _classPrivateFieldGet(_singleSpa, _this).navigateToUrl(newLocaleUrl);
      } else {
        _classPrivateFieldGet(_singleSpa, _this).triggerAppChange();
      }
    });
    _classPrivateFieldInitSpec(this, _onBeforeAppsMount, function () {
      var prevConfig = _classPrivateFieldGet(_prevConfig, _this);
      var currLocale = IlcIntl.parseUrl(_classPrivateFieldGet(_config, _this), window.location.pathname).locale;
      var currConfig = Object.assign(_classPrivateFieldGet(_get, _this).call(_this), {
        locale: currLocale
      });
      if (currConfig.locale === prevConfig.locale && currConfig.currency === prevConfig.currency) {
        return;
      }
      _classPrivateFieldGet(_set, _this).call(_this, currConfig);
      _classPrivateFieldSet(_prevConfig, _this, currConfig);
      var changeFlow = dispatchSynchronizedEvent(ilcEvents.INTL_UPDATE, _classPrivateFieldGet(_get, _this).call(_this), function (actorId) {
        var _appIdToNameAndSlot = appIdToNameAndSlot(actorId),
          appName = _appIdToNameAndSlot.appName,
          slotName = _appIdToNameAndSlot.slotName;
        var errorHandler = _classPrivateFieldGet(_appErrorHandlerFactory, _this).call(_this, appName, slotName);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        errorHandler.apply(void 0, args);
      });
      _classPrivateFieldGet(_transitionManager, _this).handleAsyncAction(changeFlow);
    });
    _classPrivateFieldInitSpec(this, _get, function () {
      var decoded = i18nCookie.decode(Cookies.get(i18nCookie.name));
      return Object.assign({}, _classPrivateFieldGet(_config, _this)["default"], decoded);
    });
    _classPrivateFieldInitSpec(this, _set, function (conf) {
      document.documentElement.lang = conf.locale;
      Cookies.set(i18nCookie.name, i18nCookie.encode(conf), i18nCookie.getOpts());
    });
    _classPrivateFieldSet(_config, this, config);
    _classPrivateFieldSet(_singleSpa, this, singleSpa);
    _classPrivateFieldSet(_appErrorHandlerFactory, this, appErrorHandlerFactory);
    _classPrivateFieldSet(_transitionManager, this, transitionManager);
    _classPrivateFieldSet(_prevConfig, this, _classPrivateFieldGet(_get, this).call(this));
    window.addEventListener(singleSpaEvents.BEFORE_MOUNT_ROUTING_EVENT, _classPrivateFieldGet(_onBeforeAppsMount, this));
  }
  return _createClass(I18n, [{
    key: "getAdapter",
    value: function getAdapter() {
      var _this2 = this;
      return {
        set: _classPrivateFieldGet(_setIntl, this),
        get: function get() {
          return _classPrivateFieldGet(_get, _this2).call(_this2);
        },
        config: _classPrivateFieldGet(_config, this)
      };
    }

    /**
     * Used only for tests
     */
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener(singleSpaEvents.BEFORE_MOUNT_ROUTING_EVENT, _classPrivateFieldGet(_onBeforeAppsMount, this));
    }
  }]);
}();
export { I18n as default };